import { useState, useEffect } from 'react';

import { PasswordResetStep } from '@quizzach/interfaces';
import {
	consoleDev,
	ConsoleStatus,
	fetchData,
	validateInput,
} from '@quizzach/utils';

interface ResetPasswordState {
	password: string;
	code: string;
	user_id: string;
}

export const useResetPasswordStep2 = (pathname: string) => {
	const [state, setState] = useState<ResetPasswordState>({
		password: '',
		code: '',
		user_id: '',
	});
	const [error, setError] = useState<boolean>(false);
	const [resetStep, setResetStep] =
		useState<PasswordResetStep>('reset_requesting');
	const [validationErrorState, setValidationErrorState] = useState<string>('');

	useEffect(() => {
		setState((prevState) => ({
			...prevState,
			user_id: pathname.split('/')[3],
			code: pathname.split('/')[4],
		}));
	}, []);

	const setNewPassword = async () => {
		try {
			const response = await fetchData<any>(
				`/api/user/reset-password-finalise`,
				{
					method: 'POST',
					body: JSON.stringify(state),
				}
			);
			if (response.status >= 300) {
				consoleDev('setNewPassword', ConsoleStatus.HTTP, response.status);
				setError(true);
			} else {
				consoleDev('setNewPassword', ConsoleStatus.SUCC);
				setResetStep('reset_success');
				setError(false);
			}
		} catch (err) {
			consoleDev('setNewPassword', ConsoleStatus.NET, err);
			setError(true);
		}
	};

	const handleInputChange = (name: string, value: string) => {
		setState((prevState) => ({ ...prevState, [name]: value }));
		setValidationErrorState(validateInput(name, value));
	};

	return {
		error,
		resetStep,
		state,
		setNewPassword,
		handleInputChange,
		validationErrorState,
	};
};
